export const getMenuStyles = (): React.CSSProperties => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  padding: '6px',
  maxWidth: '50vw',
});

export const getDropdownStyles = (disabled = false): React.CSSProperties => ({
  color: disabled ? 'rgba(0,0,0,.25)' : '#000',
  marginTop: 2,
  display: 'flex',
  flexWrap: 'wrap',
  border: '1px solid lightgrey',
  borderRadius: 8,
  padding: '4px 8px',
  backgroundColor: disabled ? 'rgba(0,0,0,.04  )' : 'white',
});
